
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: Array,
  },
})
export default class TagContainer extends Vue {
  text!: string[];
}
